import { render, staticRenderFns } from "./DvInputGroup.vue?vue&type=template&id=1e6fbd2f&lang=pug"
import script from "./DvInputGroup.vue?vue&type=script&lang=js"
export * from "./DvInputGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports